/** Left chevron path in Flickity's 100×100 viewBox (design: Group 1 (1).svg). */
export const CHEVRON_ARROW_SHAPE = 'M 54.5433 61.363 L 43.1797 49.9994 L 54.5433 38.6357'

export const flickityChevronDefaultOptions = {
  arrowShape: CHEVRON_ARROW_SHAPE
}

export function syncFlickityChevronArrows(root) {
  if (!root?.querySelectorAll) return

  root.querySelectorAll('.flickity-prev-next-button path.arrow').forEach((path) => {
    path.setAttribute('d', CHEVRON_ARROW_SHAPE)
  })
}
